import { MutationTree } from 'vuex';
import { IAfterSign } from '../types/after-sign';
import { ESigningMutation } from './signing.constants';
import { ISigningStep } from '@signing-page/signing/types/signing-step';
import { ISigningState } from '@signing-page/signing/store/signing.types';
import {
  EBankIdStep,
  EBankIdSigningType,
  EHintCodeError,
  EHintCodePending,
} from '@signing-page/signing/types/enums/bankid-se';

export const mutations: MutationTree<ISigningState> = {
  [ESigningMutation.SetBankIdSigningStep](state: ISigningState, step: EBankIdStep) {
    state.bankId = { ...state.bankId, step };
  },
  [ESigningMutation.SetBankIdLoading](state: ISigningState, isLoading: boolean) {
    state.bankId = { ...state.bankId, isLoading };
  },
  [ESigningMutation.SetTransactionData](
    state: ISigningState,
    { autoStartToken, orderRef, ssn }: { autoStartToken: string; orderRef: string; ssn: string }
  ) {
    state.bankId = { ...state.bankId, orderRef, autoStartToken, ssn };
  },
  [ESigningMutation.SetAttemptCount](state: ISigningState, attemptCount: number) {
    state.bankId = { ...state.bankId, attemptCount };
  },
  [ESigningMutation.SetError](state: ISigningState, error: string) {
    state.bankId = { ...state.bankId, error };
  },
  [ESigningMutation.SetStep](state: ISigningState, step: EBankIdStep) {
    state.bankId = { ...state.bankId, step };
  },
  [ESigningMutation.ResetBankId](state: ISigningState) {
    state.bankId = {
      ...state.bankId,
      signingType: EBankIdSigningType.None,
      step: EBankIdStep.Start,
      autoStartToken: '',
      attemptCount: 0,
      error: '',
      orderRef: '',
      ssn: '',
      hintCode: undefined,
    };
  },
  [ESigningMutation.SetSigningType](state: ISigningState, signingType: EBankIdSigningType) {
    state.bankId = { ...state.bankId, signingType };
  },
  [ESigningMutation.SetSigningStep](state: ISigningState, step: ISigningStep) {
    state.step = step;
  },
  [ESigningMutation.SetIsLoading](state: ISigningState, loading: boolean) {
    state.loading = loading;
  },
  [ESigningMutation.SetVerifyingQna](state: ISigningState, payload: boolean) {
    state.qna.isVerifying = payload;
  },
  [ESigningMutation.SetQnaError](state: ISigningState, payload: boolean) {
    state.qna.error = payload;
  },
  [ESigningMutation.SetVerifyingSignature](state: ISigningState, payload: boolean) {
    state.signature.isVerifying = payload;
  },
  [ESigningMutation.SetSignatureError](state: ISigningState, payload: boolean) {
    state.signature.error = payload;
  },
  [ESigningMutation.SetVerifyingSign](state: ISigningState, payload: boolean) {
    state.sign.isVerifying = payload;
  },
  [ESigningMutation.SetSignError](state: ISigningState, payload: boolean) {
    state.sign.error = payload;
  },
  [ESigningMutation.SetVerifyingSms](state: ISigningState, payload: boolean) {
    state.sms.isVerifying = payload;
  },
  [ESigningMutation.SetSmsError](state: ISigningState, payload: boolean) {
    state.sms.error = payload;
  },
  [ESigningMutation.SetAfterSign](state: ISigningState, payload: Partial<IAfterSign>) {
    state.afterSign = { ...state.afterSign, ...payload };
  },
  [ESigningMutation.SetBankIdHintCode](
    state: ISigningState,
    hintCode: EHintCodePending | EHintCodeError
  ) {
    state.bankId = { ...state.bankId, hintCode };
  },
  [ESigningMutation.SetSendPinRetryCount](state: ISigningState, payload: number) {
    state.sms.sendPinRetryCount = payload;
  },
};
